import React from 'react'
import { TextArea } from '@paypalcorp/pp-react'
import { MessageFormat } from '@paypalcorp/worldready'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'

const TextBox = React.forwardRef((props, ref) => {
  const worldReady = React.useContext(WorldReadyContext)
  return (
    <React.Fragment>
      <TextArea
        ref={ref}
        name={props.name}
        id={props.id}
        className={props.className}
        placeholder={new MessageFormat(worldReady, {
          id: props.placeholder,
        }).format()}
        maxCharacters={props.maxCharacters}
        value={props?.value || props?.messageToShare || ''}
        onChange={props.onChangeText}
        onBlur={props.onBlurText}
        errorText={props?.errorText || ''}
        error={!!props?.errorText}
      />
    </React.Fragment>
  )
})

export default TextBox
